import React, { useEffect, useRef, useState } from 'react';
import { Box, FormGroup } from '@material-ui/core';
import defaultLocales from 'globals/locales/default';
import { emailIsValidRe, wait } from 'globals/utils';
import FsSimpleInput from 'ui-elements/form-elements/FsDefaultInput';
import FsFormFullWidthContainer from 'ui-elements/form-elements/FsFormFullWidthContainer';
import FsPendingButton from 'ui-elements/buttons/FsPendingButton';
import FsNextArrowIcon from 'ui-elements/icons/FsNextArrow';

interface FsLoginFormProps {
  onSuccess?: () => void;
}

const FsResetPasswordForm: React.FC<FsLoginFormProps> = ({ onSuccess }) => {
  const formEl = useRef<HTMLFormElement>(null);
  const [email, setEmail] = useState<string>('');
  const [pending, setPending] = useState<boolean>(false);
  const [isFormValid, setIsFormValid] = useState<boolean>(false);

  const reset = async (): Promise<void> => {
    setPending(true);
    await wait(1000);
    setPending(false);
    if (onSuccess) onSuccess();
  };

  const handleSubmit = async (e: React.FormEvent): Promise<void> => {
    e.preventDefault();
    await reset();
  };

  useEffect(() => {
    const isDefaultFormValid = !!formEl?.current?.checkValidity();
    const isEmailValid = !!email.match(emailIsValidRe);
    setIsFormValid(isDefaultFormValid && isEmailValid);
  }, [email]);

  return (
    <form onSubmit={handleSubmit} ref={formEl}>
      <FormGroup>
        <FsFormFullWidthContainer>
          <FsSimpleInput
            fsVariant="outlined"
            name="email"
            label={defaultLocales.email}
            value={email}
            onChange={(e): void => setEmail(e.target.value)}
            fullWidth
            variant="outlined"
            autoFocus
          />
        </FsFormFullWidthContainer>

        <Box>
          <FsPendingButton
            type="submit"
            variant="contained"
            color="primary"
            pending={pending}
            disabled={!isFormValid}
            endIcon={<FsNextArrowIcon />}
            width={160}
            spaceBetween
          >
            {defaultLocales.sendLink}
          </FsPendingButton>
        </Box>
      </FormGroup>
    </form>
  );
};

export default FsResetPasswordForm;
